(function () {
var MODAL_ID = 'custom-quickview-modal';


var isClosingFromBackButton = false;

// Close Quick View when the mobile browser Back button is pressed.
window.addEventListener('popstate', function () {
  var modal = document.getElementById(MODAL_ID);

  if (modal && modal.hasAttribute('open')) {
    isClosingFromBackButton = true;

    var closeButton = modal.querySelector('.qv-close');

    if (closeButton) {
      closeButton.click();
    } else if (typeof modal.hide === 'function') {
      modal.hide();
    }

    isClosingFromBackButton = false;
  }
});

/*
* OPEN QUICK VIEW
* Fetch the product section and inject it into the modal.
  */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('.quick-view-btn');
    if (!opener) return;
    event.preventDefault();
    var modal = document.getElementById(MODAL_ID);
    if (!modal) {
      console.error('Quick View modal not found.');
      return;
    }
    var body = modal.querySelector('.modal-html-body');
    var handle = opener.getAttribute('data-handle');
    var productUrl = opener.getAttribute('data-product-url') || (handle ? '/products/' + handle : null);
    if (!body || !productUrl) {
      console.error(
        'Quick View body or product URL is missing.'
      );
      return;
    }
    var card = opener.closest('.custom-quickview-trigger');
    var loader = card ? card.querySelector('.image-loader') : null;
    /*
    * Prevent multiple clicks while the
    * Quick View section is loading.
    */
    if (opener.classList.contains('loading')) {
      return;
    }
    opener.classList.add('loading');
    opener.setAttribute( 'aria-disabled','true');
    if (loader) {
      loader.style.display = 'flex';
    }
    /*
    * Load the correct Quick View section
    * based on the screen width.
    */
    var isMobile = window.matchMedia('(max-width: 500px)').matches;
    var sectionId = isMobile ? 'quick-view-mobile-product' : 'quick-view-desktop-product';
    var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
    var requestUrl = productUrl + separator + 'section_id=' + sectionId;

    fetch(requestUrl)
    .then(function (response) {
      if (!response.ok) {
        throw new Error( 'Quick View request failed: ' + response.status  );
      }
      return response.text();
    })
    .then(function (html) {
      /*
      * Shopify Section Rendering wraps the section in .shopify-section. Remove that outer wrapper.
      */
      var temporaryContainer = document.createElement('div');
      temporaryContainer.innerHTML = html;
      var sectionWrapper = temporaryContainer.querySelector('.shopify-section');
      body.innerHTML = sectionWrapper ? sectionWrapper.innerHTML : html;
      /*
      * Open the Dawn modal after the Quick View HTML is injected.
      */
      if (typeof modal.show === 'function') {
        // Add a history entry so Back closes Quick View first.
        if (!modal.hasAttribute('open')) {
          history.pushState(
            Object.assign({}, history.state, { quickViewModal: true }),
            ''
          );
        }
        modal.show(opener);
      } else {
        console.error(
          'modal.show() is not available.'
        );
      }
    })
    .catch(function (error) {
      console.error('Quick View failed:',error);
    })
    .finally(function () {
      opener.classList.remove('loading');
      opener.removeAttribute('aria-disabled');
      if (loader) {
        loader.style.display = 'none';
      }
    });
  });

/* IMAGE AND VIDEO THUMBNAILS
* This is delegated because the Quick View
* content is injected dynamically.
*/
  document.addEventListener('click',function (event) {
    var thumbnail = event.target.closest('.qv-thumbs-strip .thumbnail-image');
    if (!thumbnail) return;
    var modal = document.getElementById( MODAL_ID );
    if (!modal) return;
    var thumbnailStrip = thumbnail.closest('.qv-thumbs-strip');
    if (!thumbnailStrip) return;
    var mainImage = modal.querySelector('#main-quickview-image');
    var mainVideo = modal.querySelector('#main-quickview-video');

    /*
    * VIDEO THUMBNAIL
    */
    if (thumbnail.classList.contains('video-thumbnail')) {
      /** Hide the main product image.*/
      if (mainImage) {
        mainImage.style.display = 'none';
      }

      /*
      * Show the product video.
      */
      if (mainVideo) {
        mainVideo.style.display = 'block';
        /* Start the video muted */
        mainVideo.muted = true;
        mainVideo.load();
        mainVideo.play().catch(function () {
          /** The video controls remain available if autoplay is blocked. */
        });

        // Scroll to the video after it becomes visible
        setTimeout(function () {
          mainVideo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100);
      }
    } else {
    /* IMAGE THUMBNAIL */
      /* Stop and hide the video. */
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.currentTime = 0;
        mainVideo.style.display = 'none';
      }

      /*
      * Change and show the main image.
      */
      if (mainImage) {
        var imageUrl = thumbnail.getAttribute('data-main-image');
        if (imageUrl) {
        mainImage.src = imageUrl;
        }

        mainImage.style.display = 'block';
      }
    }

    /* Remove the active state from all image and video thumbnails. */
    thumbnailStrip.querySelectorAll('.thumbnail-image').forEach(function (item) {
      item.classList.remove('active');
    });

    /* Add the active state to the selected thumbnail. */
    thumbnail.classList.add(
    'active'
    );
  });

  /* CLEAN UP WHEN THE MODAL CLOSES Stop the video and remove the dynamically injected Quick View HTML.
    */
  function bindModalCleanup() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    var observer = new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        if (!isClosingFromBackButton && history.state && history.state.quickViewModal) {
          history.back();
        }
        var video = modal.querySelector('#main-quickview-video');
        /* Stop the video before removing the modal content.
         */
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        var body = modal.querySelector('.modal-html-body');
        if (body) {
          body.innerHTML = '';
        }
      }
    });

    observer.observe(modal,{
        attributes: true,
        attributeFilter: ['open']
      }
    );
  }

  /* CLOSE QUICK VIEW AFTER CART DRAWER IS UPDATED.
  */
  function bindCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !cartDrawer.renderContents) {
      return;
    }

    var originalRenderContents = cartDrawer.renderContents.bind(cartDrawer);
    cartDrawer.renderContents = function () {
          var result = originalRenderContents.apply(cartDrawer,arguments);
          var modal = document.getElementById(MODAL_ID);
          if (modal && modal.hasAttribute('open')) {
            var closeButton = modal.querySelector('.qv-close');
            if (closeButton) {
              closeButton.click();
            }
          }
          return result;
    };
  }

  /* Initialize after the page DOM  is available. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',function () {
        bindModalCleanup();
        bindCartDrawer();
    });
  } else {
      bindModalCleanup();
      bindCartDrawer();
  }

  /** video button */
  document.addEventListener('click', function (event) {
    var videoButton = event.target.closest('.product-popup-modal__button.link');
    if (!videoButton) return;
    event.preventDefault();
    /* Find the current product card. Change the selector if your outer card uses a different class. */
    var productCard = videoButton.closest('.card-wrapper');
    if (!productCard) return;
    /* Find Quick View only inside this product card. */
    var quickViewButton = productCard.querySelector('.quick-view-btn');
    if (!quickViewButton) return;
    /*  Open Quick View for the current product. */
    quickViewButton.click();
    /* * Wait until Quick View HTML is loaded, then select the video thumbnail. */
    var modal = document.getElementById('custom-quickview-modal');
    var videoCheck = setInterval(function () {
      var videoThumbnail = modal.querySelector('.quickview-video-thumbnail');
      if (!videoThumbnail) return;
      videoThumbnail.click();
      clearInterval(videoCheck);
    }, 100);
  });

  document.addEventListener("DOMContentLoaded", () => {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || !cartDrawer.renderContents) return;

    const originalRenderContents = cartDrawer.renderContents.bind(cartDrawer);

    cartDrawer.renderContents = function (...args) {
      originalRenderContents(...args);

      const modal = document.getElementById("custom-quickview-modal");

      if (modal?.hasAttribute("open")) {
        modal.querySelector(".qv-close")?.click();
      }
    };
  });
})();